/**
 * Page RTE wrap. Loaded from sections/main-page.liquid as type="module".
 */

const SELECTOR = '[data-section-type="page"]'

function init(root) {
  if (root.dataset.pageInit) return
  root.dataset.pageInit = 'true'

  root.querySelectorAll('iframe').forEach((el) => {
    if (el.parentElement?.classList.contains('rte__iframe')) return
    const wrapper = document.createElement('div')
    wrapper.className = 'rte__iframe'
    el.parentNode.insertBefore(wrapper, el)
    wrapper.appendChild(el)
  })
  root.querySelectorAll('table').forEach((el) => {
    if (el.parentElement?.classList.contains('rte__table-wrapper')) return
    const wrapper = document.createElement('div')
    wrapper.className = 'rte__table-wrapper'
    wrapper.tabIndex = 0
    el.parentNode.insertBefore(wrapper, el)
    wrapper.appendChild(el)
  })
}

function initAll(scope = document) {
  if (scope.matches?.(SELECTOR)) init(scope)
  scope.querySelectorAll(SELECTOR).forEach(init)
}

initAll()
document.addEventListener('shopify:section:load', (event) => initAll(event.target))
